import { render } from "./EventCardComponent.vue?vue&type=template&id=013d2902"
import script from "./EventCardComponent.vue?vue&type=script&lang=js"
export * from "./EventCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__